import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/var/www/html/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/var/www/html/layouts/default.vue").then(m => m.default || m)),
  desktop: defineAsyncComponent(() => import("/var/www/html/layouts/desktop.vue").then(m => m.default || m)),
  mobile: defineAsyncComponent(() => import("/var/www/html/layouts/mobile.vue").then(m => m.default || m))
}